module.exports = __webpack_public_path__ + "img/baharan.288feef8.png";